import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CategoriesManagement from './pages/CategoriesManagement';
import LevelsManagement from './pages/LevelsManagement';
import SubCategoriesManagement from './pages/SubCategoriesManagement';
import GoalsManagement from './pages/GoalsManagement';
import ExercisesManagement from './pages/ExercisesManagement';
import MealPlansManagement from './pages/MealPlansManagement';
import DoctorAdviceManagement from './pages/DoctorAdviceManagement';
import TrainingsManagement from './pages/TrainingsManagement';
import SubscriptionPackageManagement from './pages/SubscriptionPackegeManagment';
import MainLayout from './components/MainLayout';
import NotFoundPage from './pages/NotFoundPage';

const AppRoutes = () => {
  // You might want to add proper authentication check here
  const isAuthenticated = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      console.warn('No authentication token found');
    }
    return !!token;
  };

  const PrivateWrapper = ({ children }) => {
    useEffect(() => {
      console.log('Rendering PrivateWrapper', { 
        authenticated: isAuthenticated(),
        children: children?.type?.name 
      });
    }, [children]);

    return isAuthenticated() ? (
      <MainLayout>{children}</MainLayout>
    ) : (
      <Navigate to="/login" replace />
    );
  };

  const LoginRoute = () => {
    // If already logged in, redirect to categories page
    const authenticated = isAuthenticated();
    
    useEffect(() => {
      console.log('Login Route Authentication Status:', authenticated);
    }, [authenticated]);

    return authenticated ? <Navigate to="/categories" replace /> : <Login />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route 
          path="/dashboard" 
          element={
            <PrivateWrapper>
              <Dashboard />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/categories" 
          element={
            <PrivateWrapper>
              <CategoriesManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/sub-categories" 
          element={
            <PrivateWrapper>
              <SubCategoriesManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/levels" 
          element={
            <PrivateWrapper>
              <LevelsManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/goals" 
          element={
            <PrivateWrapper>
              <GoalsManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/trainings" 
          element={
            <PrivateWrapper>
              <TrainingsManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/exercises" 
          element={
            <PrivateWrapper>
              <ExercisesManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/meal-plans" 
          element={
            <PrivateWrapper>
              <MealPlansManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/doctor-advice" 
          element={
            <PrivateWrapper>
              <DoctorAdviceManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/subscription-packages" 
          element={
            <PrivateWrapper>
              <SubscriptionPackageManagement />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="/" 
          element={
            <PrivateWrapper>
              <Navigate to="/dashboard" />
            </PrivateWrapper>
          } 
        />
        <Route 
          path="*" 
          element={<NotFoundPage />} 
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
